/**
 * Opens the first-visit country picker once per browser and remembers the
 * visitor's choice. Choosing in the footer selector also counts as a choice.
 * "International" is remembered separately so the footer shows it as the current choice.
 */
const STORAGE_KEY = 'et-country-chosen';
const REGION_KEY = 'et-region';
const COUNTRY_FORMS = ['country-welcome-form', 'footer-localization', 'header-localization'];
const ACTIVE_CLASSES = ['bg-surface-secondary', 'font-medium'];

function store(key, value) {
  try {
    if (value === null) localStorage.removeItem(key);
    else localStorage.setItem(key, value);
  } catch {
    // storage unavailable: the choice may not persist
  }
}

function read(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function remember() {
  store(STORAGE_KEY, '1');
}

function hasChosen() {
  return read(STORAGE_KEY) === '1';
}

function showInternational() {
  for (const label of document.querySelectorAll('[data-country-label]')) {
    label.classList.add('hidden');
    label.classList.remove('inline-flex');
  }
  for (const label of document.querySelectorAll('[data-international-label]')) {
    label.classList.remove('hidden');
    label.classList.add('inline-flex');
  }
  for (const id of COUNTRY_FORMS) {
    const form = document.getElementById(id);
    if (!form) continue;
    for (const button of form.querySelectorAll('button[name="country_code"][aria-current]')) {
      button.removeAttribute('aria-current');
      button.classList.remove(...ACTIVE_CLASSES);
    }
  }
  for (const button of document.querySelectorAll('[data-international-choice]')) {
    button.setAttribute('aria-current', 'true');
    button.classList.add(...ACTIVE_CLASSES);
  }
}

document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target.closest('[data-international-choice]') : null;
  if (!target) return;
  store(REGION_KEY, 'international');
  remember();
  showInternational();
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form instanceof HTMLFormElement && COUNTRY_FORMS.includes(form.id)) {
    remember();
    // International submits country US (dollar prices) but stays labelled International; a real country replaces it.
    if (event.submitter?.closest('[data-international-choice]')) return;
    store(REGION_KEY, null);
  }
});

if (read(REGION_KEY) === 'international') showInternational();

const dialog = document.getElementById('country-welcome');

if (dialog instanceof HTMLDialogElement) {
  for (const button of dialog.querySelectorAll('[data-country-welcome-keep]')) {
    button.addEventListener('click', () => {
      remember();
      dialog.close();
    });
  }
  dialog.addEventListener('cancel', remember);

  if (!hasChosen()) dialog.showModal();
}
